import React, { Component } from 'react';
import { Grid, Row, Col, Table } from 'react-bootstrap';

import { PropTypes } from 'prop-types';

import { DataUpdateCommand } from '../commands/DataUpdateCommand';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { TitleRow } from '../../TitleRow';

export class DataUpdates extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            edition: undefined,
            table: {
                data: [],
            },
            commands: {
                dataUpdate: new DataUpdateCommand()
            },
            actions: {
                isLoadingEdition: true,
                isLoadingData: true
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        const { actions } = this.state;
        this.context.selectApp('bussched', false);        

        const edition = this.context.getOwnEdition();
        edition.addObserver(this);
        
        actions.isLoadingEdition = false;

        this.setState({
            edition: edition,
            actions: actions
        });
    }

    componentWillUnmount() {
        this.state.edition.removeObserver(this);
    }    

    updateNetwork() {
        const { actions } = this.state;

        actions.isLoadingData = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.state;
            this.getDataUpdates(edition);
        });        
    }

    getDataUpdates(edition) {
        const { commands, actions } = this.state;

        actions.isLoadingData = true;
        commands.dataUpdate.list(
            edition.network,
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a, true)
        );

        this.setState({
            actions: actions
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ''
            }
        });
    }

    successCallback(result) {
        const { table, actions } = this.state;        
        
        actions.isLoadingData = false;
        table.data = result;        

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    errorCallback(message, reset = false) {
        const { table, actions } = this.state;

        actions.isLoadingData = false;
        if (reset) {
            table.data = [];
        }

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    renderLoading(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderData(isWaiting) {
        const { table } = this.state;

        return (
            <Grid className="margin-top-15" fluid>
                <Row>
                    <Col sm={12}>
                        <div className="table-loading">
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th>Data de Atualização</th>
                                        <th>Linhas</th>
                                        <th>Paragens</th>                                        
                                    </tr>
                                </thead>
                                <tbody className={isWaiting ? "overlay" : ""}>
                                    {
                                        !Array.isArray(table.data) ? Object.getOwnPropertyNames(table.data).map((key, idx) =>
                                            <tr key={`data-update-${idx}`}>
                                                <td className="cell-align-top">{key}</td>
                                                <td className="cell-align-top">{table.data[key].lines.map((line, i) => <li key={`data-update-${idx}-line-${i}`}>{line.code} | {line.goName}</li>)}</td>
                                                <td className="cell-align-top">{table.data[key].stops.map((stop, i) => <li key={`data-update-${idx}-stop-${i}`}>{stop.code} | {stop.name}</li>)}</td>
                                            </tr>
                                        ) : null
                                    }
                                </tbody>
                            </Table>

                            {this.renderLoading(isWaiting)}
                        </div>
                    </Col>
                </Row>
            </Grid>
        )
    }

    render() {
        const { actions, message } = this.state

        return (
            <div>
                <TitleRow title="Atualizações de Dados" showSeparator={true} />

                {this.renderData(actions.isLoadingData || actions.isLoadingEdition)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/bussched/updates/DataUpdates.js